module.exports = __webpack_public_path__ + "static/media/occupied.967dbf69.svg";